import React from 'react';
import styled from 'styled-components';
import I10n from '../features/i10n';
import PropTypes from 'prop-types';
import { getMachineExpertTooltip } from '../features/get-rules/ducks';
import InformationIcon from '../atoms/information-icon';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.span`
  display: inline-block;
  cursor: pointer;
  color: #626469 !important;
`;

class MachineExpertPopupDisplayer extends React.Component {
  static propTypes = {
    openModal: PropTypes.func,
    closeModal: PropTypes.func,
    starterType: PropTypes.string
  }

  constructor(props) {
    super(props);
    this.state = {
      markdownText: '',
      isLoading: true,
    };
    this._isMounted = false;
  }

  componentDidMount = () => {
    this._isMounted = true;

    this.updateStateIfMounted({ isLoading: true });
    getMachineExpertTooltip().then((result) => {
      this.updateStateIfMounted({ markdownText: result.data, isLoading: false });
    }).catch((error) => {
      getMachineExpertTooltip(true).then((result) => {
        this.updateStateIfMounted({ markdownText: result.data });
      }).finally(() => {
        this.updateStateIfMounted({ isLoading: false });
      });
    });
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  }

  updateStateIfMounted = (newState) => {
    if (this._isMounted) {
      this.setState(newState);
    }
  }

  render = () => {
    return (
      <Container>
        {!this.state.isLoading &&
          <IconWrapper
            title={I10n.get('saved_configuration.export.machine_expert.howto')}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              this.props.openModal({
                modalType: 'markdown_reader',
                modalProps: {
                  title: I10n.get('saved_configuration.export.machine_expert.howto'),
                  markdownText: this.state.markdownText,
                  onButtonClick: () => { this.props.closeModal(); },
                  starterType: this.props.starterType
                },
              });
            }}
          >
            <InformationIcon size="small"></InformationIcon>
          </IconWrapper>
        }
      </Container>
    );
  }
}

export default MachineExpertPopupDisplayer;
